module.exports = __webpack_public_path__ + "static/media/indisponivel.a98f6cb4.jpg";